import * as React from "react";
import {FC} from "react";
import {FormProvider, useForm} from "react-hook-form";
import {Button, DialogActions} from "@mui/material";
import {Brick, BrickBox, BrickButton, BrickProducts, BrickShipping, BrickStatus, BrickText} from "../../BrickMailType";
import {BrickTextEditor} from "./BrickTextEditor";
import {BrickButtonEditor} from "./BrickButtonEditor";
import {BrickProductsEditor} from "./BrickProductsEditor";
import {BrickBoxEditor} from "./BrickBoxEditor";
import {BrickShippingEditor} from "./BrickShippingEditor";
import {BrickStatusEditor} from "./BrickStatusEditor";
import {useBrickEditorStyles} from "../../styles/BrickEditorStyles";

export type BrickEditorProps = {
  brick: Brick
  onChange: (brick: Brick) => void
  onCancel: () => void
  onDelete: () => void
};

export const BrickEditor: FC<BrickEditorProps> = ({brick, onChange, onCancel, onDelete, ...props}) => {
  const brickType = brick as any
  const methods = useForm<Brick>();
  const classes = useBrickEditorStyles();

  const {handleSubmit} = methods;
  const formSubmit = handleSubmit((data: Brick) => {
    onChange(data);
  })

  return (
    <div className={classes.brickEditor}>
      <FormProvider {...methods}>
        <form onSubmit={formSubmit} id={"myform"} style={{width: '100%'}}>
          {brickType.image && <></>}
          {brickType.text && <BrickTextEditor brick={brick as BrickText} onChange={onChange} {...props}/>}
          {brickType.button && <BrickButtonEditor brick={brick as BrickButton} onChange={onChange} {...props}/>}
          {brickType.products && <BrickProductsEditor brick={brick as BrickProducts} onChange={onChange} {...props}/>}
          {brickType.box && <BrickBoxEditor brick={brick as BrickBox} onChange={onChange} {...props}/>}
          {brickType.shipping && <BrickShippingEditor brick={brick as BrickShipping} onChange={onChange} {...props}/>}
          {brickType.status && <BrickStatusEditor brick={brick as BrickStatus} onChange={onChange} {...props}/>}
        </form>
      </FormProvider>
      <DialogActions sx={{display: 'flex', justifyContent: 'space-between'}}>
        <Button variant={"outlined"} onClick={onDelete}>
          Delete
        </Button>

        <div>
          <Button onClick={formSubmit} variant={"contained"}>
            Update
          </Button>
          <Button onClick={onCancel}>
            Hide
          </Button>
        </div>
      </DialogActions>
    </div>
  );
}